import s from './style.module.scss';

import { Display } from '@/components/Display/Display';

import { CloseCircleFilled } from '@ant-design/icons';
import { useEffect } from 'react';
import { fileTypeMap, parseStatusDic } from '@/utils/Page/constant';

import WebImgage from './Image';
import FileInfo from './FileInfo';
import UseSendFile from '@/pages/hooks/useSendFile';
import IconImg from './IconImg';
const SendFile = ({ file, index, close, changeFile, needParse = false }) => {
    const changeFileInfo = (data) => {
        changeFile(index, { ...file, ...data });
    };
    const { parseResult } = UseSendFile({ file, changeFileInfo, needParse });
    useEffect(() => {
        //接口返回的文件状态和解析状态都是status字段，前端处理下
        let { status, ...result } = parseResult;
        changeFileInfo({ ...result, parse_status: status });
    }, [parseResult]);

    return (
        <>
            <div className={s['file-item']} data-form="send" data-type={file.type}>
                <span
                    className={s['close']}
                    onClick={() => {
                        close(index);
                    }}
                >
                    <CloseCircleFilled />
                </span>
                <div className={s['left']}>
                    <Display show={file.type === fileTypeMap.img}>
                        <WebImgage canClickImage={false} file={file} from="send" preview={false}></WebImgage>
                    </Display>
                    <Display show={file.type === fileTypeMap.file || file.type === fileTypeMap.link}>
                        <IconImg ing={file.parse_status !== parseStatusDic.success} file={file} className={s['file-icon']} />
                    </Display>
                </div>
                <div className={s['right']}>
                    <FileInfo file={file}></FileInfo>
                </div>
            </div>
        </>
    );
};
export default SendFile;
